import React from 'react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { Box, Button, ButtonGroup, IconButton, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';

const MenuItemContent = ({ label, description }) =>
  description ? (
    <Box>
      <Text>{label}</Text>
      <Text fontSize="sm" color="gray.500">
        {description}
      </Text>
    </Box>
  ) : (
    label
  );

// A solid primary action button with a caret menu of alternative actions, separated by a
// thin divider. menuItems: [{ label, onClick, description?, icon? }]
const SplitActionButton = ({
  label,
  onClick,
  menuItems,
  menuAriaLabel,
  isLoading = false,
  loadingText,
  isDisabled = false,
  title,
  minW = '120px'
}) => (
  <ButtonGroup colorScheme="blue" size="md" variant="solid" isAttached>
    <Button
      minW={minW}
      px={8}
      fontWeight="semibold"
      onClick={onClick}
      isLoading={isLoading}
      loadingText={loadingText}
      isDisabled={isDisabled}
      title={title}
    >
      {label}
    </Button>
    <Menu placement="bottom-end">
      <MenuButton
        as={IconButton}
        icon={<ChevronDownIcon />}
        aria-label={menuAriaLabel}
        isDisabled={isDisabled || isLoading}
        borderLeftWidth="1px"
        borderLeftColor="whiteAlpha.500"
      />
      <MenuList p={2} borderRadius="lg" boxShadow="lg">
        {menuItems.map((item) => (
          <MenuItem key={item.label} onClick={item.onClick} icon={item.icon} borderRadius="md" py={item.description ? 3 : 2}>
            <MenuItemContent label={item.label} description={item.description} />
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  </ButtonGroup>
);

export default SplitActionButton;
